import { ContactElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Contact extends ContactElement {}
export default Contact;